<script setup lang="ts" generic="T extends HeadlineData">

import type { HandlungBausteinProps, HeadlineData } from '@/api/handlungen/types';

defineProps<HandlungBausteinProps<T>>();
</script>

<template>
  <h5 class="text-gray-900 font-medium mb-0 mt-5">
    {{ baustein.data.title }}
  </h5>
</template>
